import WorkflowActionsRoute from 'cio/pods/base/overview/workflow/actions/route';
import { action } from '@ember/object';

export default class ActionsRoute extends WorkflowActionsRoute {
  model() {
    // Reload the model in order to get updated actions
    return this.modelFor('campaigns.campaign').reload();
  }

  @action
  loading(transition) {
    // If coming from the campaign_loading route, don't show this route's
    // loading template again.
    // If we do show it, the UI will jump between loading routes, which makes
    // for a jarring experience.
    // If we don't render this route, the parent loading route will keep
    // spinning until this route resolves properly.
    if (transition.from?.name.includes('campaign_loading')) {
      return false;
    }

    return true;
  }
}
